import { createUseStyles } from 'react-jss'
import { BLUE } from '@omnilert/components'

export default createUseStyles({
  selectedLink: {
    '& svg, & div': {
      stroke: `${BLUE} !important`,
      color: `${BLUE} !important`
    }
  },
  navText: {
    color: 'var(--tab__nav__text__color)',
    fontSize: '12px',
    paddingTop: '3px',
    fontFamily: 'BentonSansMedium'
  },
  tabBarButton: {
    '& svg': {
      stroke: 'var(--tab__stroke__color)',
      width: '26px'
    },
    background: 'none',
    border: '0',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1',
    justifyContent: 'center',
    textDecoration: 'none'
  },
  tabBarContainer: {
    background: 'var(--primary__page__background)',
    borderTop: '1px solid var(--tab__border__color)',
    display: 'flex',
    flex: 'none',
    height: ({ hideTabBar }) => hideTabBar ? '0px' : '65px',
    justifyContent: 'center',
    opacity: ({ hideTabBar }) => hideTabBar ? 0 : 1,
    transition: 'opacity 0.3s ease-out',
    width: '100%'
  }
})
